// New Window's registration: the window `newwindow` and Home's New Window item (New Session is the session's).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('newwindow', { module: () => import('./newwindow.js'), css: 'windows/newwindow/newwindow.css', title: () => 'New Window', perMac: true, place: ['home', 'front'] })
registerHomeItem({ id: 'newwindow', label: 'New Window', symbol: 'plus.rectangle.on.rectangle', needs: 'paired', section: 'toolbar', order: 120, open: (app, key) => app.openWindow('newwindow', { mode: 'window' }, key) })
